import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NATIVE_APP_BANNER_DISMISS_KEY } from "utilities/Constant";

interface NativeAppPromoState {
  bannerDismissed: boolean;
}

const initialState: NativeAppPromoState = {
  bannerDismissed: sessionStorage.getItem(NATIVE_APP_BANNER_DISMISS_KEY) === "true",
};

const nativeAppPromoSlice = createSlice({
  name: "nativeAppPromo",
  initialState,
  reducers: {
    setNativeAppBannerDismissed(state, action: PayloadAction<boolean>) {
      state.bannerDismissed = action.payload;
    },
  },
});

export const { setNativeAppBannerDismissed } = nativeAppPromoSlice.actions;

export const selectIsNativeAppBannerDismissed = (state: { nativeAppPromo: NativeAppPromoState }) =>
  state.nativeAppPromo.bannerDismissed;

export default nativeAppPromoSlice.reducer;
